/**
 * Simulated network latency for the mock API layer.
 * Replace the bodies of the functions in this folder with real `fetch` calls
 * once the backend is available — call sites do not need to change.
 */
export function delay<T>(value: T, ms = 320): Promise<T> {
  return new Promise((resolve) => setTimeout(() => resolve(value), ms));
}

export function clone<T>(value: T): T {
  return JSON.parse(JSON.stringify(value)) as T;
}

export { apiFetch, ApiError, API_BASE_URL, USE_MOCK_API, uploadFile, trackVisitRemote } from './http';
export type { ApiErrorShape, ApiRequestOptions } from './http';
export { api, apiBlob } from './arrex/client';
